import { render } from "./IdeaManagementView.vue?vue&type=template&id=b8f584de&scoped=true&ts=true"
import script from "./IdeaManagementView.vue?vue&type=script&lang=ts"
export * from "./IdeaManagementView.vue?vue&type=script&lang=ts"

import "./IdeaManagementView.vue?vue&type=style&index=0&id=b8f584de&scoped=true&lang=css"
import "./IdeaManagementView.vue?vue&type=style&index=1&id=b8f584de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f584de"]])

export default __exports__